var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.92969 7.33398V4.66732H9.26302V7.33398H11.9297V8.66732H9.26302V11.334H7.92969V8.66732H5.26302V7.33398H7.92969ZM8.59635 14.6673C4.91435 14.6673 1.92969 11.6827 1.92969 8.00065C1.92969 4.31865 4.91435 1.33398 8.59635 1.33398C12.2784 1.33398 15.263 4.31865 15.263 8.00065C15.263 11.6827 12.2784 14.6673 8.59635 14.6673ZM8.59635 13.334C10.0108 13.334 11.3674 12.7721 12.3676 11.7719C13.3678 10.7717 13.9297 9.41514 13.9297 8.00065C13.9297 6.58616 13.3678 5.22961 12.3676 4.22941C11.3674 3.22922 10.0108 2.66732 8.59635 2.66732C7.18187 2.66732 5.82531 3.22922 4.82512 4.22941C3.82492 5.22961 3.26302 6.58616 3.26302 8.00065C3.26302 9.41514 3.82492 10.7717 4.82512 11.7719C5.82531 12.7721 7.18187 13.334 8.59635 13.334Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCircle);
export default __webpack_public_path__ + "static/media/add-circle.23017427795e6eaba087c5e17f7ef271.svg";
export { ForwardRef as ReactComponent };